import { INDETERMINATE_STATUS } from '@/consts/app'

export const AGENTS_TYPE_EMPLOYEE = 'EMPLOYEE'
export const AGENTS_TYPE_EMERGENCY = 'EMERGENCY'
export const AGENTS_TYPE_EXTERNAL = 'EXTERNAL'
export const AGENTS_TYPE_SELF_EMPLOYED_WORKER = 'SELF'
export const AGENTS_TYPE_NOMINEE = 'NOMINEE'

export const AGENTS_CONTRACT_CDI = 'CDI'
export const AGENTS_CONTRACT_CDD = 'CDD'
export const AGENTS_CONTRACT_INTERNSHIP = 'INTERNSHIP'
export const AGENTS_CONTRACT_APPRENTICE = 'APPRENTICE'
export const AGENTS_CONTRACT_PRO_TRAINING = 'PRO_TRAINING'
export const AGENTS_CONTRACT_INTERIM = 'INTERIM'

export const AGENTS_CONTRACT_STATUS_AGENT_EXPLOIT = 'AGENT_EXPLOIT'
export const AGENTS_CONTRACT_STATUS_AGENT_MAITRISE = 'AGENT_MAITRISE'
export const AGENTS_CONTRACT_STATUS_INGENIEUR_CADRE = 'INGENIEUR_CADRE'

export const AGENTS_CONTRACT_PERIOD_WEEK = 'WEEK'
export const AGENTS_CONTRACT_PERIOD_MONTH = 'MONTH'

export const AGENTS_GENDER_UNKNOWN = 0
export const AGENTS_GENDER_MALE = 1
export const AGENTS_GENDER_FEMALE = 2

export const AGENTS_GENDERS_LIST = [
  {
    value: AGENTS_GENDER_UNKNOWN,
    label: 'N/A'
  },
  {
    value: AGENTS_GENDER_MALE,
    label: 'Homme'
  },
  {
    value: AGENTS_GENDER_FEMALE,
    label: 'Femme'
  }
]

export const AGENTS_CIVILITY_LIST = [
  {
    value: AGENTS_GENDER_UNKNOWN,
    label: 'N/A'
  },
  {
    value: AGENTS_GENDER_MALE,
    label: 'Monsieur'
  },
  {
    value: AGENTS_GENDER_FEMALE,
    label: 'Madame'
  }
]

export const AGENTS_BLOOD_TYPES = [
  'O+',
  'A+',
  'B+',
  'AB+',
  'O-',
  'A-',
  'B-',
  'AB-'
]

export const AGENTS_ITEM_TYPES = [
  {
    value: 0,
    label: 'Autre'
  },
  {
    value: 1,
    label: 'Tenue'
  },
  {
    value: 2,
    label: 'Badge'
  },
  {
    value: 3,
    label: 'Matériel'
  },
  {
    value: 4,
    label: 'Clé'
  }
]

export const AGENTS_ITEM_INDEXED_TYPES = _.keyBy(AGENTS_ITEM_TYPES, 'value')

export const AGENTS_TYPES_LIST = [
  {
    value: AGENTS_TYPE_EMPLOYEE,
    label: 'Employé',
    icon: 'fa fa-user-shield'
  },
  {
    value: AGENTS_TYPE_EMERGENCY,
    label: 'Urgence',
    icon: 'far fa-life-ring'
  },
  {
    value: AGENTS_TYPE_EXTERNAL,
    label: 'Prestataire',
    icon: 'fa fa-hands-helping'
  },
  {
    value: AGENTS_TYPE_SELF_EMPLOYED_WORKER,
    label: 'Travailleur non salarié',
    icon: 'fa fa-user-times'
  },
  {
    value: AGENTS_TYPE_NOMINEE,
    label: 'Candidat',
    icon: 'fa fa-user-graduate'
  }
]

export const AGENTS_TYPES = {
  '?': INDETERMINATE_STATUS,
  ..._.keyBy(AGENTS_TYPES_LIST, 'value')
}

export const AGENTS_CONTRACTS = [
  {
    value: AGENTS_CONTRACT_CDI,
    label: 'CDI'
  },
  {
    value: AGENTS_CONTRACT_CDD,
    label: 'CDD'
  },
  {
    value: AGENTS_CONTRACT_INTERNSHIP,
    label: 'Stage'
  },
  {
    value: AGENTS_CONTRACT_APPRENTICE,
    label: 'Apprentissage'
  },
  {
    value: AGENTS_CONTRACT_PRO_TRAINING,
    label: 'Contrat pro'
  },
  {
    value: AGENTS_CONTRACT_INTERIM,
    label: 'Intérim'
  }
]

export const AGENTS_CONTRACT_PERIODS = [
  {
    value: AGENTS_CONTRACT_PERIOD_WEEK,
    label: 'Semaine'
  },
  {
    value: AGENTS_CONTRACT_PERIOD_MONTH,
    label: 'Mois'
  }
]

export const AGENTS_CONTRACT_STATUS_LIST = [
  {
    value: AGENTS_CONTRACT_STATUS_AGENT_EXPLOIT,
    label: 'Agents d’exploitation, employés administratifs, techniciens'
  },
  {
    value: AGENTS_CONTRACT_STATUS_AGENT_MAITRISE,
    label: 'Agents de maîtrise sécurité'
  },
  {
    value: AGENTS_CONTRACT_STATUS_INGENIEUR_CADRE,
    label: 'Ingénieurs et cadres sécurité'
  }
]

export const AGENTS_EMPTY_PICTURE = 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABQAAD/4QMsaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjUtYzAxNCA3OS4xNTE0ODEsIDIwMTMvMDMvMTMtMTI6MDk6MTUgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1NUQ0MERBMkI2RTExMUU2QjM4MUM0Rjc0QzNBQUVDQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1NUQ0MERBM0I2RTExMUU2QjM4MUM0Rjc0QzNBQUVDQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjY5QzUyNjdGQjZEQjExRTZCMzgxQzRGNzRDM0FBRUNCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjY5QzUyNjgwQjZEQjExRTZCMzgxQzRGNzRDM0FBRUNCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4ADkFkb2JlAGTAAAAAAf/bAIQAAgICAgICAgICAgMCAgIDBAMCAgMEBQQEBAQEBQYFBQUFBQUGBgcHCAcHBgkJCgoJCQwMDAwMDAwMDAwMDAwMDAEDAwMFBAUJBgYJDQsJCw0PDg4ODg8PDAwMDAwPDwwMDAwMDA8MDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwM/8AAEQgBAAEAAwERAAIRAQMRAf/EAIQAAQADAAIDAQEAAAAAAAAAAAAICQoGBwMEBQIBAQEAAAAAAAAAAAAAAAAAAAAAEAABBAEDAgQDBgMEBQ0AAAAAAQIDBAURBgcSCCExEwlBUWFxgZEiMhRCFRahUmIjU3OToxexcoKSorIzQ2OzlCYYEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwC8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+JJI4o3yyvbHFG1XSSOVEa1qJqqqq+CIiAQv5g9wLtc4Znnxua5Dh3RuCur2S7e2uz+azskYiL0SyRL6ESrr5PkRQIC7x96bDQzyxbA4Mu5CtppDe3Bl46ciL83V6kFpF+xJfvA6Sve81zrI5/8ALeLdh1Gqq+mlluTsKifDVWXYdfwQDw0/eY5+Zp+/4y4/s/3v28OVg1+zryEoHb+0/encs1eLfPBCR19U/dX8Fmut+nxVlazWan4zATm4l9yvtU5WsVsa/eU/HmbtInp4vd0CUGK9zkajEuMfLVVyqvgnq+IE8aV2nkqsF7HW4b9G0xJKtyvI2WKRi+TmPYqtci/NFA9oAAAAAAAAAAAAAAAAAAAAAAAAAAOhe4XuO4z7aNjz715FyvprKrodvbbqq1+RylpE1SGrEqpqieb3u0axPFy+SKGaDuc7/ub+467kcX/NptgcazOcynsHDTuYySH4fv7TUZJZcqJ4oukfyYgEGAAAAAAASq7d+8jnHtryVVdk7nlyW0mzI/Jcf5ZzrGKsMVUV6MjVeqByp/HErV+evkBph7VO8TjDus21Ld2xKu3964iNq7o4/vStdcqa+HrQuRGpYgcvgkjWpovg9rV0RQlqAAAAAAAAAAAAAAAAAAAAAAAAdV81cv7S4I4z3TyjvWz6WG2zVWVlRjmtnu2nr0V6ddHeck0io1Pl+pfyoqgZAe4HnzffcfyRmOR993NbFxyxYTBRPctPFUWqvpVKzXeTWp+p2mr3aud4qB0iAAAAAAAAA5xxvyPvHiXeuA5B2FmZsFufblltnH3Yl/K7T9cUzPKSKRurXsd4OaqooGvHtP7k9ud0XEeJ5BxEcWMz1d38u3vtlknW7HZOJqLIxNfzLFIipJE5fNq6L+ZrkQJLgAAAAAAAAAAAAAAAAAAAAAAM2nu1dw1jfXLNDg7B23JtfiprZtwMY5UZZztuJr3dSaeKVoXNYnyc6QCooAAAAAAAAAAAT89uTuHn4J7hcDjslbdHsblGSHbW6IFcvpxzWJEbQtqmioixTuRqr/ce8DWIAAAAAAAAAAAAAAAAAAAAABxje26cfsfZu6955aVIcZtPEXcvkJXeTYaUD53r+DAMRO8d05bfG7Nzbzzsy2MzuvKW8tlJlVV1nuTOmk01+CK7RPoBxwAAAAAAAAAAAfpj3xPZLE90ckbkdHI1VRzXIuqKip4oqKBs97VuTn8xdvHEvIdiy21ks5t+szOzM8lyNPWpd/38LwJAgAAAAAAAAAAAAAAAAAAAAhN7iu6X7T7OuZrMLlbYzNCpg4kTw1bk7sFaVNf9U94GRgAAAAAAAAAAAAAGm/2hd0vzXa/lMBK5Vfs3eWSp12L8ILcNe61U+2SaQC1EAAAAAAAAAAAAAAAAAAAAFZ3uzWpq/aLkY4l0Zd3XhIJ/qxHSyf8AeYgGXAAAAAAAAAAAAAAGhf2XLUz+OObabl/yK+5MZLEnydLUka/+yNALqQAAAAAAAAAAAAAAAAAAAAVt+63jX3+z/cVhmumI3FhLkmn91bC1/wDlmQDLGAAAAAAAAAAAAADRJ7MGNfDxPzFll19O/uunVZ8tatJHr/76AXOAAAAAAAAAAAAAAAAAAAAAiF37bW/q/tB51xqM9R9Dby5piImqouHniyKqn3V1Ax+AAAAAAAAAAAAAA1F+0vtb+Q9pVLMKzpfvXdWZy3UqeLmwPjxqfdrTUCzUAAAAAAAAAAAAAAAAAAAAHE9+7ag3nsfeO0LKItfdGEv4mZFTVOm5XfCvh/0wMPeWxd3B5XJ4XJwrWyWItzUshXd5xz13rHIxfsc1UA+eAAAAAAAAAAAAGyvs72NPxz2w8JbUt1/2t+rtencyddU0VlrINW7O1fqj5lRQJKgAAAAAAAAAAAAAAAAAAAAAZB+/3jleM+7LlzExVP2mNz+TTcuIT4PhzDEtSOT6JO6Rv3AQ3AAAAAAAAAAAHanB2wp+UeYuM+PYK62k3ZuPH0LcLfP9q+dq2XfY2FHuX7ANs1evFUrwVYGJHBWjbFCxPJrGIjWp9yIB5gAAAAAAAAAAAAAAAAAAAAAKPveS4b/e7e4450xlVPXwdh+1d0zMRqKte11WKMj101VGSNlZr/jQCgAAAAAAAAAAAAXC+z7w3/VHLe7uYslVSTGca43+X4SR6NVq5XKo5qubr46x1myeKeXWgGjsAAAAAAAAAAAAAAAAAAAAAAB1RzlxNg+c+J98cV7hX0qG78bJVhuonU6rbYqS1LTU+KwzMY/T46aeSgYwd9bL3BxzvLc2xN1UnY/cW0slYxeYqO/hmrvVjlavxa7TqavkrVRU8wOKAAAAAAAAAPYqVLV+3Vo0q8lu7dlZBUqxNV8kssjkaxjGp4qrnKiIiAbC+y/t9h7beA9p7Fsxt/qvItXOb8sN0Xqy11jFliRU8212NZC1U8F6Or+JQJWgAAAAAAAAAAAAAAAAAAAAAAAFFfuy9ptu/wBHc/sags7qdeDH8rY2vHq/0o/8urldGpqqMRWwzKvk1I3eSPUChMAAAAAAAABbp7WPabb5I5Ar8/7xoKzYPG9z/wCqV549W5TOxpqx7OpNFjpapIqp/wCb0In6XogaTAAAAAAAAAAAAAAAAAAAAAAAAAB6l+hRylG5jMnThyGOyEEla/QsxtlhnhlarJI5I3orXNc1VRUVNFQDMz37+31nOCsnl+VOKsbPmeGMhO6xkMdA10tjbT5F1WOZPFzquq6Ml/g8GSfwucFWAAAAAAAJ5dlnY7vXul3HDm8nFZ2zw7hbTW7j3c9itddcxUV9HG9SaSSqng9/6Y08Xau6WuDVRs3Z22ePtrYPZezcNXwG2NuVGUsPiaremOGKNPD6uc5dXOcuqucqucqqqqByYAAAAAAAAAAAAAAAAAAAAAAB11yJy5xjxLiJc5yTvrDbMxsTVVJMnajikkVE16YYdVklcvwaxqqvwQCojnr3h9u41L2C7etmybitojo499blY+tSav5m9dbHsVs0nwc1ZXx/WNQJjdlHfFs/uk21DhczNT2zzJha6f1DtPrRjLzGIiOvY5Hrq+NfN7NVdGvgurdHKE8Z4IbMM1azCyxXsMdHPBI1Hsex6aOa5q6oqKi6KigVLdy/tQ8Z8mWcnu3hXJRcVbuuOdPPt18bpdv2pVTVemJmslRXL/oupifCMCnbk7sC7r+LLMzMpxNk9z42LqVue2o1czUcxvm9UrIs0af62NigRRv7a3FirEtTJ4DI461A5Wz1rNWaJ7FTzRzXtRU+8D16+EzNx7IqmIu2pJFRsccNeR7nKvkiI1qqoEleOOybuk5Ss1Y9tcNbgq0bSI5uczddcRQRnxf+4vei16J8mdS/JALau3L2httbcs0NzdxW4od5ZCvIyaPYODfLFikVq69Nu25I5p08E1axsafBVcgFzeFwuH25icfgtv4urhcLioG1sZiaUTIK9eFiaNZHGxEa1E+SIBGnur7suO+1jZE2c3JZiy28cnE9uzNiQytbbyE6eCPeiarFXYv65FTT4N1cqIBV/wAI+8fbbaZiu4Dj+OWlNM7093bRRWyQRuc5USbH2JFSRG6onUyVq6J+hzgLhOKO4Thfm/Gx5Li/kTD7pRzUdNjYZ0ivwdXwnpTdE8a/85ifQDuUAAAAAAAAAAAAAAAAAAV8dxfuScAcCXLm26FyXlHfNPVlnb+3ZYnVqsiaax276q6KNya+LWI9yaKjkRQKauYPdL7neS3WqW2MrS4mwE6qjaW3Yuu6rFarVa+/YR8mq666xpGBXnndw7g3Tkp8zufOZDceYs6fuctlLMtyzJp5dc0znvXT6qB8cD6+A3BnNq5rGbj21lreCz2GsMtYrMUZXQWK80a6tfHIxUVFQC+LtV92nFXa+P2X3OwfyzIxMZBU5SxldXVp9FRqOyVSJFdG7TxWSFqtX/Rt8wLpNqbv2rvrCU9y7M3Fjt04C+1HVMxi7Mdqu/wRVTric5Ecmvi1fFPigHIwPDPWr2o1hswR2Ynfqilaj2r9zkVAPHVpUqLPSpVIacf+jgjbG38GoiAe0B87LZfE4HHW8xnMnUwuJx8ay38penjrVoI083yyyuaxiJ81UCpHuh917jzYdW/tXt+jh5H3n/mQSbusMe3A0XaadceqskuPaqrojemPw163J4AZ8uQeRN68q7syu+OQdxW90bozMnXeylx/U7RP0xxtTRscbE8GsYiNangiAcLA9zH5HIYi7WyWKvWMZkaT0lp5CpK+GeJ6eTo5I1RzVT5ooE7eHvcm7peJf2dKfeTeR9u1fTYuE3axbr/TYvi1l1HMtIqoumrpHfYBcH29+6lwdyzbxu2uQ60vD27r3RCyfJTMmwk07kamjL+jPR6nKunrMa1E83gWfwTw2YYbNaZlivYY2WvYicj2PY9NWua5NUVFRdUVAPKAAAAAAAAAAAAADPz7j/f9mclnNxdvPC2YdjsBiXvx/I29qMqpPetN/LPjqkrF1ZDEv5JXtXV7kcxNGIvWFIyqqqqquqr4qqgfwAAAAAOwOPuVuSuKcs3Ocb75zWy8mmnXPirckDZERdemWNq9Ejdf4XtVPoBP/YXu1d0u1IYam5v6a5Frx6ddrK4/9rccifD1aD68f4xKoEicf71Wfa2JuV4Ax8r0T/OmqbgljRV/wxyUX6fe5QPYve9XlfzJje32poqL0SWdxP8ABfhq1lDx/EDojfHu99ym4obFXaWE2psGKZFRlyvUlyFyP5dEluV0P4wqBAHk/nnmTme6l7lDkbN7xexVdBUu2VSpCq+fo1IuiCPX/AxAOpAAAAAAAWj9gffzn+Ctw4fi3k7KS5fhjOW2VoLtp7ny7bmmd0pYhcuqrV6l1lj/AIU1ezxRzXhp1hmhsQxWK8rJ4J2NkgnjcjmPY5NWua5NUVFRdUVAPIAAAAAAAAAAAISd/wD3CydvHbzuHL4a2tbfG9XrtnZD2LpJDZtxvWa43z0/bQNe9q6adfQi+YGRxznPc573K971Vz3uXVVVfFVVVA/IAAAAAAAAAAAAAAAAAAAAAGm/2pu4iflTha5xZuK66zu3htYKdOWV2sljBWev9i74arXVjoF+TUj18XAWogAAAAAAAAAADNX7v3KlndPPe3OMa9ly4fjDBRyT1UX8v8zzPTZmf4fH9u2u36aL8wKkwAAAAAAAAAAAAAAAAAAAAAAE9PbZ5Us8Yd2OwIXWXQ4bkRZdoZyHXRsiZFEWprr4fltxwrr8tfmBrMAAAAAAAAAAPy97I2OkkcjI2IrnvcuiIieKqqr8gMVncfyE/lXnfljf7nOdBuTct+fHtc7q6ajJVirMRfk2JjUQDpQAAAAAAAAAAAAAAAAAAAAAAB9nbmcu7Y3DgtyY2R0OQwGQrZGjKxelzZasrZWKi/DxagG37Y+6ae+NmbS3nj9P2O7MPRy9VrV6kay7AydG6/Tr0A5SAAAAAAAAA6X7jd5R8fcC8wbxkcrVwW0srNXc1dF9d1Z8cOn19R7QMVCqqqqquqr4qqgfwAAAAAAAAAAAAAAAAAAAAAAAA1we3NvJm9Oz7iSbrc+xtyra29bVy6r1Y61JEz/ddGgE4AAAAAAAAAFeXujbol232e74rV7HoT7pyWIwqJr4vjltsnlb97IHAZTAAAAAAAAAAAAAAAAAAAAAAAAABo79mvdEuR4Q5K2pNY602zu5tqpX1/RFkacSron1fA4C4UAAAAAAAABTH7zu5m1OKeI9osnVk2b3RZycsKLp1RY+m6LxT4p12kAztgAAAAAAAAAAAAAAAAAAAAAAAAC6z2XtzNq8hc0bQknVFzOAx2UqwKvgrqFmSKRUT56Wm6gaFAAAAAAAAAGer3o8ss/InCWDR+rcbt3KXFj+S3LUTNfvSugFKgAAAAAAAAAAAAAAAAAAAAAAAAAsz9pjLLje7ijV6+luc2nmaLm/3ulIbKJ+MGoGo0AAAAAAAABme94bJus9zW18ajuqPF7Cx69Ov6Xz3r7nJ/1WtUCqAAAAAAAAAAAAAAAAAAAAAAAAAATn9trJuxvedw2nV0R5GbLUpV180kxNxWp972tA1sgAAAAAAAAMunu1Q24u7i4+y1zYbG0cJJj1cmiLCiTsVW/NPUa9PtArKAAAAAAAAAAAAAAAAAAAAAAAAAEveweG3P3hcCspNc6Zu4lkejU1X0Y6s75l+xI2uVfoBsDAAAAAAAAAQC74+xzD92eIw2aw2bh2lyftKCSthczYiWSndqSO61p3EZ+dqNfq6ORuqsVXflcjvAM5HMXab3A8Ez2P+InG2Uo4mBX9O6KMa3sU9rNNXpcr9bGJ4+UnSv0AjmAAAAAAAAAAAAAAAAAAAAAAA7m4p7eeaubbsVPjHjnM7pje7pky0NdYsfFo5GuWW7N0QN0VfFFfr9ANBXYf7d//AOb8v/xV5NzFTP8AKE9F9TEYigivo4WOy1EnVJn6LNO5NWdbWta1vUjerq1AtQAAAAAAAAAAPHLFFPG+GeNk0UidMkT0RzXIvwVF8FAidyt2NdrvMS2rO6eKsZjs1bc6STcmARcReWRyaeo+Sp6bZVT/ANVr0+gFcHJPswUZZLNviLmKWqxztauD3ZSSVGp8nX6XSq//ABgIKch+2T3c7C/cT1th19+Y6B/Sy7te7FcfIn95tWRYrH+7AhnurjfkLY1iervLY+e2tPWcrJ2ZXH2KnSqfWVjU/tA4UAAAAAAAAAAAAADkm39m7v3bOyttba2X3JYkcjGQ4ylPbcrl+GkLHATB4/8Abj7u+QPTlh4tn2lRc5qOvbnsQ4tGtd/F6MrvXVPsjUCdHHfsv5iV8NnlfmSpSha5rp8TtWi+w97fi1Ld30UYv19BwFjHFXt49qPE/wC3s0ONa+8czX6XJnd2v/m83WxUVr2wyolaNyKmuscLVAmlTpU8fXjqUKkNGpCnTDVrxtijYifBrGIiJ9wHsgAAAAAAAAAAAAAAAPUvY+hk60lPJUq+QqS/+LVsxtljd9rHoqL+AEed69n/AGx8hPmn3RwltWzbnb0Pv1KLKFj7Ulp+i7X66gRX3X7S3ahn4pUwlbc+yrEiqrZsblnWGtVfky+yygEb9z+yxgZpFdsvna/j4f4Yc1horjvsV9axVT7+kDpLP+zPzZU6/wCmuUtnZvT9CXmXsfr9vRDa0A6pv+0t3c1HvbXo7SyjWr4SVc2jUd9n7iGFfxQDi1v2tu8+tr6PHONv6eXobgxDdf8AbWowPHU9rrvSsaetxlQoa+fr7hwy6f7G5IByan7Tfd5aVqT4ja2OR3m6xnInIn2+jHKv4Ado4D2bOeris/qPkbZODav6v2b799yJ9jq1dNfvA7q237K9VkzH7v56ls1/D1K+HwbYH/VElsW5k+/oAkdtP2iu1vBNT+oLe7t7SeareybajPs6aMMC/wDaAlFsrsj7VNguqzYDhHbctyousOQyldcpPr81fddMBJXFYXDYKslLB4mlhqbfKpRgjrxJp/gia1P7APpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB//9k='

export const RATING_OPTIONS = [
  {
    value: 1,
    label: '1'
  },
  {
    value: 2,
    label: '2'
  },
  {
    value: 3,
    label: '3'
  },
  {
    value: 4,
    label: '4'
  },
  {
    value: 5,
    label: '5'
  }
]

export const AGENTS_REGEX = {
  cardNumber: {
    regex: /^([A-Z]{3})-([0-9]{3})-([0-9]{4})-([0-9]{2})-([0-9]{2})-([0-9]{11})$/,
    label: 'AAA-000-0000-00-00-00000000000'
  },
  socialSecurityNumber: {
    regex: /^([123478])([0-9]{2})(0[1-9]|1[0-2]|3[1-9]|4[0-2]|[5-9][0-9]|20)([0][1-9]|2[AB]|[1-9][0-9])([0-9]{3})(00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})(0[1-9]|[1-8][0-9]|9[0-7])?$/,
    label: '0 00 00 00 000 000 00'
  }
}
